import React, { FC } from "react";

interface ChartsCategoryComponentProps {
    data: string[];
    colors: string[];
}

const ChartsCategoryComponent: FC<ChartsCategoryComponentProps> = ({
    data,
    colors,
}) => {
    return (
        <div className="sprint-key-container">
            {data.map((key, index) => {
                return (
                    <span className="sprint-key" key={index}>
                        <span
                            style={{
                                backgroundColor: colors[index],
                            }}
                            className="ion-stop"
                        />
                        {key}
                    </span>
                );
            })}
        </div>
    );
};

export default ChartsCategoryComponent;
